import { ITdcsConfig } from '../../config/tdcs/tdcs.types';

// Default data for init of context
const tdcsDefault: ITdcsConfig = {
  type: 'client',
  version: 'failsafe-backup',
  analytics: {
    adobeEnabled: true,
  },
  logger: {
    level: 'info',
  },
};

export default tdcsDefault;
